import { HTTP_INTERCEPTORS } from '@angular/common/http';

import { DefaultHeaderInterceptor } from './default-header-interceptor';
import { AuthorizationInterceptor } from './authorization-interceptor';

export const httpInterceptorProviders = [
  { provide: HTTP_INTERCEPTORS, useClass: DefaultHeaderInterceptor, multi: true },
  { provide: HTTP_INTERCEPTORS, useClass: AuthorizationInterceptor, multi: true }
];
